export default {"src":"/_next/static/media/graph.fe5b683d.svg","height":21,"width":21,"blurWidth":0,"blurHeight":0};